import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import { makeStyles, styled } from "@material-ui/core/styles";
import { Button, ButtonGroup, Chip, colors } from "@material-ui/core";
import { ArrowBackIos, ArrowForwardIos, Done, FirstPage, LastPage, Reply } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const ButtonsSearch = (props) => {
  const { onClickButton, openButtonsSearch, procIdSearch, setOpenButtonsSearch } = props;
  const { t } = useTranslation(["forms"]);
  const [mouseInterA, setMouseInterA] = useState(false);
  const [mouseInterB, setMouseInterB] = useState(false);
  const [mouseInterC, setMouseInterC] = useState(false);
  const [mouseInterD, setMouseInterD] = useState(false);
  return (
    <>
      <ButtonGroup
        orientation="horizontal"
        aria-label="horizontal primary button group"
        other
        style={{ marginLeft: "1rem" }}
      >
        <Button key="last"
          style={{ color: openButtonsSearch ? "#fff" : "#d3d3d3", borderRadius: 0, borderBottom: 'solid 1px white' }}
          onClick={(event) => onClickButton(procIdSearch, "last")}
          name={"last"}
          onMouseEnter={() => setMouseInterA(true)}
          onMouseLeave={() => setMouseInterA(false)}
          disabled={!openButtonsSearch}
        >
          <FirstPage />
          {mouseInterA && openButtonsSearch && (
            <div className='tooltip'>
              {t("last")}
            </div>
          )}
        </Button>,

        <Button key="previous"
          style={{ color: openButtonsSearch ? "#fff" : "#d3d3d3", borderRadius: 0, borderBottom: 'solid 1px white' }}
          disabled={procIdSearch === 0 ? true : false }
          onClick={(event) => onClickButton(procIdSearch, "before")}
          onMouseEnter={() => setMouseInterB(true)}
          onMouseLeave={() => setMouseInterB(false)

          }
        >
          <ArrowBackIos />
          {mouseInterB && openButtonsSearch && (
            <div className='tooltip'>
              {t("previous")}
            </div>
          )}
        </Button>,
        <Button key="next"
          style={{ color: openButtonsSearch ? "#fff" : "#d3d3d3", borderRadius: 0, borderBottom: 'solid 1px white' }}
          disabled={ procIdSearch === 0 ? true : false }
          onClick={(event) => onClickButton(procIdSearch, "next")}
          name={"next"}
          onMouseEnter={() => setMouseInterC(true)}
          onMouseLeave={() => setMouseInterC(false)}

        >
          <ArrowForwardIos />
          {mouseInterC && openButtonsSearch && (
            <div className='tooltip'>
              {t("next")}
            </div>
          )}
        </Button>,

        <Button key="first"
          hidden={true}
          style={{ color: openButtonsSearch ? "#fff" : "#d3d3d3", borderRadius: 0, borderBottom: 'solid 1px white' }}
          disabled={!openButtonsSearch}
          onClick={(event) => onClickButton(procIdSearch, "first")}
          onMouseEnter={() => setMouseInterD(true)}
          onMouseLeave={() => setMouseInterD(false)}
        >
          <LastPage />
          {mouseInterD && openButtonsSearch && (
            <div className='tooltip'>
              {t("first")}
            </div>
          )}
        </Button>

      </ButtonGroup>
      <Button style={{ color: '#fff' }}
        onClick={() => setOpenButtonsSearch(true)}
        startIcon={<Reply />} >
        {t("undo")}
      </Button>
    </>

  );
};

export default ButtonsSearch;
